import { formatMedicationTimings, Medication } from "@/model/Medication";
import PatientDataCell from "./PatientDataCell";

type MedicationListCellProps = {
  medications: Medication[];
  rowIndex: number;
};

const MedicationListCell = ({ medications, rowIndex }: MedicationListCellProps) => (
  <PatientDataCell rowIndex={rowIndex} className="pe-8">
    {medications.length === 0 ? (
      "-"
    ) : (
      <div className="flex flex-col justify-center gap-1">
        {medications.map((medication, index) => (
          <span key={`${medication.name}-${index}`} className="text-nowrap">
            <span className="font-semibold text-primary/90">{medication.name}</span>
            {medication.timing.length > 0 && (
              <span className="font-normal text-primary/60">
                {` · ${formatMedicationTimings(medication.timing)}`}
              </span>
            )}
          </span>
        ))}
      </div>
    )}
  </PatientDataCell>
);

export default MedicationListCell;
